<script type="text/javascript">

import GoogleMapsLoader from 'google-maps';
GoogleMapsLoader.KEY = process.env.MIX_GOOGLE_MAPS_ID;
GoogleMapsLoader.LIBRARIES = ['places'];
let map = null;
let autocomplete = null;

  export default {
    props: ['type', 'pc', 'website'],
    data() {
      return {
        default_content: {
          type: 'valuation',
          title: 'Valuation',
          active: 1,
          image: '',
          color: 'dark',
          opacity: '',
          pad_t: '5',
          pad_r: '0',
          pad_b: '5',
          pad_l: '0',
          steps: [
            {icon: 'ri:edit-box-line', title: 'Complete Form', desc: 'Enter property information'},
            {icon: 'ri:bar-chart-2-line', title: 'Instant Valuation', desc: 'Receive an instant valuation'},
            {icon: 'ri:mail-send-line', title: 'Email CMA', desc: 'Receive CMA via email'},
          ],
          steps_icon_color: 'revinre',
          steps_title_color: 'white',
          steps_text_color: 'gray-500',
          form_text_color: 'gray-500',
          form_btn_color: 'revinre',
          form_btn_pre_icon: 'ri:bar-chart-2-line',
          form_btn_text: 'Get Results',
          form_btn_post_icon: '',

          report_image: '',
          report_color: 'light',
          report_opacity: '',
          report_pad_t: '5',
          report_pad_r: '0',
          report_pad_b: '5',
          report_pad_l: '0',
          report_icon: 'ri:line-chart-fill',
          report_icon_color: 'revinre',
          report_h2: 'Reported Home Value',
          report_h2_color: 'black',
          report_h2_desc: 'Your instant home valuation is below. Your customized CMA report has been sent to the email address provided. If you have any additional questions or concerns, please contact us.\n * Current numbers are pulled from several sources which reflect an estimated home value and is not an official property appraisal.',
          report_h2_desc_color: 'muted',
          post_btn: [
            {color: 'revinre', pre_icon: '', text: "I'm Selling", post_icon: '', url: '/selling'}
          ],
          
          valuation_color: 'white',
          valuation_image: '/storage/fm/revinre-nc/clip art/Real Estate Listings.png',
          valuation_image_alt: 'Reported Home Value',
          valuation_title_color: 'black',
          valuation_text_color: 'muted',
        },

        selling_times: [
          'This month',
          '1-3 months',
          '3-6 months',
          '6+ months',
        ],

        found_property: true,
        loading: false,
        started: false,
        message_sent: false,

        input_form: {
          full_address: '',
          name: '',
          email: '',
          phone: '',
          selling: '',
          recaptcha_token: '',
        },

        default_item: {
          full_address: '',
          Address: '',
          City: '',
          StateOrProvince: '',
          PostalCode: '',
          name: '',
          email: '',
          phone: '',
          selling: '',
          comments: '',
          valuations: {
            zillow: {},
            rpr: {},
          },
          cloud: {},
          recaptcha_token: '',
        },
        item: {
          valuations: {
            zillow: {},
            rpr: {},
          },
          cloud: {},
          recaptcha_token: '',
        },
      }
    },
    created() {
      // console.log(this.pc);
      if(this.pc && this.pc.init == 'Yes') { for(var i in this.default_content) { this.pc[i] = this.default_content[i]; } this.pc.init = ''; }
      if(!this.pc.steps) { this.pc.steps = []; this.$forceUpdate(); }
      if(!this.pc.post_btn) { this.pc.post_btn = []; this.$forceUpdate(); }

      if(this.type != 'editor') {
        if(this.user && this.user.name) { this.input_form.name = this.user.name; }
        if(this.user && this.user.email) { this.input_form.email = this.user.email; }
        if(this.user && this.user.phone) { this.input_form.phone = this.user.phone; }
        this.item = JSON.parse(JSON.stringify(this.default_item));

        var $this = this;
        GoogleMapsLoader.load(function(google) {
          if(document.getElementById("autocomplete")){ autocomplete = new google.maps.places.Autocomplete(
            /** @type {!HTMLInputElement} */(document.getElementById('autocomplete')), {types: ['geocode']}
          ); }
          google.maps.event.addListener(autocomplete, 'place_changed', function() {
            var place = autocomplete.getPlace();
            if(place && place.formatted_address) { $this.item.full_address = place.formatted_address; }
          }.bind(this));
        });
      }

    },
    methods: {
      async submit_form() {
        // history.pushState({}, null, '/valuation');
        if(this.loading == true) { console.log("disabled"); return; } this.loading = true; this.found_property = true;
        this.item = JSON.parse(JSON.stringify(this.default_item));
        this.input_form.recaptcha_token = await this.getRecaptcha();
        if(
          !this.input_form.recaptcha_token ||
          this.input_form.recaptcha_token == 'failed'
        ) {
          this.$noty.error("There was an issue with the Google ReCaptcha validation. Please try submitting the form again. If that does not work, try refreshing the page. If this does not solve the issue, please reach out to us.");
          this.loading = false; return;
        }
        if(
          !this.input_form.full_address ||
          !this.input_form.name ||
          !this.input_form.email
        ) {
          this.$noty.error("Please enter an address, full name and email address before continuing.");
          this.loading = false; return;
        }
        this.$http.post('/listings/valuation', this.input_form).then(res => {
          // console.log(res);
          this.started = true;
          this.loading = false;
          if(res.data && res.data.output) { for(var i in res.data.output) { this.item[i] = res.data.output[i]; } }
          if(!this.item.valuations.zillow.amount && !this.item.valuations.rpr.amount) { this.found_property = false; }
          // history.pushState({}, null, '/valuation/results');
          $("html, body").animate({ scrollTop: $("#scrolltome_cma").offset().top - 70 }, 2000);
        }).catch(res => { console.log(res); this.loading = false; this.popupErrors(res); });
      },
    }
  }
</script>

<template>
  <div>

    <div v-if="type == 'editor'">
      <div class="p-3">
        <div class="row">
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="pc.active" Title="Active :" :Options="[{name:'Yes',value:1},{name:'No',value:0}]" v-tippy content="Display this section on the live website?"></w-field>
          </div>
        </div>
        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Form background and padding :</h6>

        <div class="row">
          <div class="col-sm-4">
            <w-field SimpleDataType="String" v-model="pc.image" Title="Background image URL :"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" Title="Background color :" :Options="theme_colors" v-model="pc.color"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="Number" v-model="pc.opacity" Min="0" Max="10" Title="Background color opacity :" v-tippy content="Background color transparency (0 through 10)"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="Number" v-model="pc.pad_t" Min="0" Max="20" Title="Top padding :" v-tippy content="Padding for the top of the section (0 through 20)"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="Number" v-model="pc.pad_r" Min="0" Max="20" Title="Right padding :" v-tippy content="Padding for the right of the section (0 through 20)"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="Number" v-model="pc.pad_b" Min="0" Max="20" Title="Bottom padding :" v-tippy content="Padding for the bottom of the section (0 through 20)"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="Number" v-model="pc.pad_l" Min="0" Max="20" Title="Left padding :" v-tippy content="Padding for the left of the section (0 through 20)"></w-field>
          </div>
        </div>
        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Valuation Steps :</h6>



        <div class="row">
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="pc.steps_icon_color" Title="Step icon color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="pc.steps_title_color" Title="Step title color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="pc.steps_text_color" Title="Step description color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-12">
            <div class="form-group">
              <draggable handle=".handle" v-bind="{animation: 200}" v-model="pc.steps">
                <transition-group tag="div">
                  <div v-for="(step, step_i) in pc.steps" :key="'f1'+step_i">
                    <div class="row m-0 align-items-end">
                      <div class="col-3 p-0">
                        <w-field SimpleDataType="String" v-model="step.icon" Title="Icon :"></w-field>
                      </div>
                      <div class="col-3 p-0">
                        <w-field SimpleDataType="String" v-model="step.title" Title="Title :"></w-field>
                      </div>
                      <div class="col p-0">
                        <w-field SimpleDataType="String" v-model="step.desc" Title="Text :"></w-field>
                      </div>
                      <div class="_w-40 pb-2">
                        <button class="btn btn-white" type="button" v-tippy content="Delete" @click="pc.steps.splice(step_i, 1); $forceUpdate()"><Icon icon="ri:delete-bin-line"></Icon></button>
                      </div>
                      <div class="_w-40 pb-2">
                        <button class="btn btn-white handle" type="button" v-tippy content="Drag to arrange"><Icon icon="ri:drag-move-2-fill"></Icon></button>
                      </div>
                    </div>
                  </div>
                </transition-group>
              </draggable>
              <button class="btn btn-sm btn-primary" type="button" @click="pc.steps.push({icon: '', title: '', desc: ''}); $forceUpdate()"><Icon icon="ri:add-line" height="18"></Icon> Add Step</button>
            </div>
          </div>
        </div>
        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Form Details :</h6>

        <div class="row">
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="pc.form_text_color" Title="Form text color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="pc.form_btn_color" Title="Form button color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String" v-model="pc.form_btn_pre_icon" Title="Form button pre icon :"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String" v-model="pc.form_btn_text" Title="Form button text :"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String" v-model="pc.form_btn_post_icon" Title="Form button post icon :"></w-field>
          </div>
        </div>
        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Report background and padding :</h6>
        <div class="row">
          <div class="col-sm-4">
            <w-field SimpleDataType="String" v-model="pc.report_image" Title="Background image URL :"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" Title="Background color :" :Options="theme_colors" v-model="pc.report_color"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="Number" v-model="pc.report_opacity" Min="0" Max="10" Title="Background color opacity :" v-tippy content="Background color transparency (0 through 10)"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="Number" v-model="pc.report_pad_t" Min="0" Max="20" Title="Top padding :" v-tippy content="Padding for the top of the section (0 through 20)"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="Number" v-model="pc.report_pad_r" Min="0" Max="20" Title="Right padding :" v-tippy content="Padding for the right of the section (0 through 20)"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="Number" v-model="pc.report_pad_b" Min="0" Max="20" Title="Bottom padding :" v-tippy content="Padding for the bottom of the section (0 through 20)"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="Number" v-model="pc.report_pad_l" Min="0" Max="20" Title="Left padding :" v-tippy content="Padding for the left of the section (0 through 20)"></w-field>
          </div>
        </div>
        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Report H2 title :</h6>
        <div class="row">
          <div class="col-sm-4">
            <w-field SimpleDataType="String" v-model="pc.report_icon" Title="Section icon :" v-tippy content="Section icon"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="pc.report_icon_color" Title="Section icon color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String" v-model="pc.report_h2" Title="H2 title :" v-tippy content="Section title"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="pc.report_h2_color" Title="H2 title color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="Textarea" v-model="pc.report_h2_desc" Title="H2 description :" v-tippy content="Section description appearing below the section title"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="pc.report_h2_desc_color" Title="H2 description color : " :Options="theme_colors"></w-field>
          </div>
        </div>
        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Bottom buttons :</h6>
        <div class="form-group">
          <draggable handle=".handle" v-bind="{animation: 200}" v-model="pc.post_btn">
            <transition-group tag="div">
              <div v-for="(btn, btn_i) in pc.post_btn" :key="'f2'+btn_i">
                <div class="row m-0 align-items-end">
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String" v-model="btn.pre_icon" Title="Pre icon :"></w-field>
                  </div>
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String" v-model="btn.text" Title="Text :"></w-field>
                  </div>
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String" v-model="btn.post_icon" Title="Post icon :"></w-field>
                  </div>
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String List, Single" v-model="btn.color" Title="Color : " :Options="theme_colors"></w-field>
                  </div>
                  <div class="col p-0">
                    <w-field SimpleDataType="String" v-model="btn.url" Title="URL :"></w-field>
                  </div>
                  <div class="_w-40 pb-2">
                    <button class="btn btn-white" type="button" v-tippy content="Delete" @click="pc.post_btn.splice(btn_i, 1); $forceUpdate()"><Icon icon="ri:delete-bin-line"></Icon></button>
                  </div>
                  <div class="_w-40 pb-2">
                    <button class="btn btn-white handle" type="button" v-tippy content="Drag to arrange"><Icon icon="ri:drag-move-2-fill"></Icon></button>
                  </div>
                </div>
              </div>
            </transition-group>
          </draggable>
          <button class="btn btn-sm btn-primary" type="button" @click="pc.post_btn.push({color: '', pre_icon: '', text: '', post_icon: '', url: ''}); $forceUpdate()"><Icon icon="ri:add-line" height="18"></Icon> Add button</button>
        </div>
        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Valuation Box Details :</h6>
        <div class="row">
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="pc.valuation_color" Title="Background color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String" v-model="pc.valuation_image" Title="Address image/icon :"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String" v-model="pc.valuation_image_alt" Title="Address image/icon alt :"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="pc.valuation_title_color" Title="Title color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="pc.valuation_text_color" Title="Text color : " :Options="theme_colors"></w-field>
          </div>
        </div>
      </div>
    </div>

    <div v-else>
      <section>
        <div class="position-absolute _pos-l-0 _pos-t-0 _pos-r-0 _pos-b-0 _z-n1 _bg-repeat-none _bg-size-cover _bg-position-center" :style="'background-image: url('+(pc['image'] ? fullurlencode(pc['image']) : '')+')'"></div>
        <div class="position-absolute _pos-l-0 _pos-t-0 _pos-r-0 _pos-b-0 _z-n1" :class="'bg-'+pc['color']+' _o-'+pc['opacity']"></div>
        <div class="container-fluid m_py-35" :class="'pt-'+pc['pad_t']+' pr-'+pc['pad_r']+' pb-'+pc['pad_b']+' pl-'+pc['pad_l']">
          <div class="row justify-content-center">
            <div class="col-lg-6 col-xl-7" data-aos="fade-zoom-in">
              <ul class="list-unstyled list-inline text-center text-uppercase mb-5 d-flex justify-content-center align-items-center text-white">
                <li v-for="(step, step_i) in pc['steps']" :key="'step'+step_i" class="list-inline-item position-relative m-0" :class="step_i < (pc['steps'].length - 1) ? 'pr-6' : ''">
                  <div v-if="step_i < (pc['steps'].length - 1)" class="position-absolute _pos-r-0 _pos-t-50p _transform-y-n50p mr-4"><Icon icon="ri:arrow-right-fill" height="40" class="text-gray-900" /></div>
                  <Icon :icon="step.icon" height="45" class="mb-2 text-revinre" :class="'text-'+pc['steps_icon_color']" />
                  <h2 class="_f-s-20" :class="'text-'+pc['steps_title_color']">{{ step.title }}</h2>
                  <div class="small" :class="'text-'+pc['steps_text_color']">{{ step.desc }}</div>
                </li>
              </ul>
              <b-form @submit.prevent="submit_form()">
                <div class="row">
                  <div class="col-sm-12">
                    <div class="form-group">
                      <input id="autocomplete" name="address" type="text" placeholder="Full property address..." class="form-control form-control-lg" v-model="input_form.full_address" autocomplete="off" onfocus="this.setAttribute('autocomplete', 'new-password');" required>
                    </div>
                  </div>
                  <div class="col-sm-12">
                    <w-field SimpleDataType="String" Size="lg" v-model="input_form.name" placeholder="Full name..." Required></w-field>
                  </div>
                  <div class="col-sm-12">
                    <w-field SimpleDataType="String" Size="lg" v-model="input_form.email" placeholder="Email address..." Required></w-field>
                  </div>
                  <div class="col-sm-12">
                    <w-field SimpleDataType="Phone" Size="lg" v-model="input_form.phone" placeholder="Phone number..." Required></w-field>
                  </div>
                  <div class="col-sm-12">
                    <w-field SimpleDataType="String List, Single" Size="lg" v-model="input_form.selling" :options="selling_times" placeholder="When are you looking to sell?" Required></w-field>
                  </div>
                </div>
                <p class="small font-weight-light mb-1" :class="'text-'+pc['form_text_color']">By continuing you agree to {{app_name}}'s <a href="/privacy" target="_blank">Privacy Policy</a> and <a href="/terms" target="_blank">Terms & Conditions</a>.</p>
                <p class="small font-weight-light mb-4" :class="'text-'+pc['form_text_color']">This site is protected by ReCaptcha and the Google <a href="https://policies.google.com/privacy" target="_blank">Privacy Policy</a> and <a href="https://policies.google.com/terms" target="_blank">Terms of Service</a> apply.</p>
                <button type="submit" class="btn btn-lg btn-block" :class="'btn-'+pc['form_btn_color']" :disabled="loading">
                  <Icon v-if="pc['form_btn_pre_icon']" :icon="pc['form_btn_pre_icon']" height="20"></Icon>
                  <span v-if="pc['form_btn_pre_icon'] && pc['form_btn_text']" class="border-left mx-3"></span>
                  <span class="spinner-border spinner-border-sm" v-if="loading"></span> {{ pc['form_btn_text'] }}
                  <span v-if="pc['form_btn_post_icon'] && pc['form_btn_text']" class="border-left mx-3"></span>
                  <Icon v-if="pc['form_btn_post_icon']" :icon="pc['form_btn_post_icon']" height="20"></Icon>
                </button>
              </b-form>
            </div>
          </div>
        </div>
      </section>

      <div id="scrolltome_cma"></div>

      <section v-show="this.started && !loading">
        <div class="position-absolute _pos-l-0 _pos-t-0 _pos-r-0 _pos-b-0 _z-n1 _bg-repeat-none _bg-size-cover _bg-position-center" :style="'background-image: url('+(pc['report_image'] ? fullurlencode(pc['report_image']) : '')+')'"></div>
        <div class="position-absolute _pos-l-0 _pos-t-0 _pos-r-0 _pos-b-0 _z-n1" :class="'bg-'+pc['report_color']+' _o-'+pc['report_opacity']"></div>
        <div class="container-fluid m_py-35" :class="'pt-'+pc['report_pad_t']+' pr-'+pc['report_pad_r']+' pb-'+pc['report_pad_b']+' pl-'+pc['report_pad_l']">
          <div class="row justify-content-center">
            <div class="col-sm-12" data-aos="fade-zoom-in">

              <div class="text-center mb-5">
                <Icon v-if="pc['report_icon']" :icon="pc['report_icon']" height="45" class="mb-2" :class="'text-'+pc['report_icon_color']"></Icon>
                <h2 v-if="pc['report_h2']" class="mb-3" :class="'text-'+pc['report_h2_color']" data-aos="fade-zoom-in">{{pc['report_h2']}}</h2>
                <p v-if="pc['report_h2_desc']" :class="'text-'+pc['report_h2_desc_color']" data-aos="fade-zoom-in">{{pc['report_h2_desc']}}</p>
              </div>

              <div v-if="!found_property" class="alert alert-warning py-3">
                <Icon icon="ri:close-fill" height="25" class="float-right _c-pointer m-0" @click="found_property = '1'" />
                Home valation data could not be found for the address entered. You may try another address or if you have any additional questions or concerns please contact us.
              </div>
              <div v-if="item.cloud == 'Could not find any comparable listings on the MLS around that subject property address.'" class="alert alert-warning py-3">
                <Icon icon="ri:close-fill" height="25" class="float-right _c-pointer m-0" @click="item.cloud = '1'" />
                Comparable listings could not be found for the address entered and we were unable to generate an automated Comparative Market Analysis. One of our agents will review the request and attempt to create a manual report for you. If you have any additional questions or concerns please contact us.
              </div>

              <div class="card mb-4" :class="'bg-'+pc['valuation_color']">
                <div class="p-5d">
                  <div class="row m-0">
                    <div v-if="pc['valuation_image']" class="_w-110 d-none d-md-block p-4 border-right border-light">
                      <img :src="formatImage(pc['valuation_image'])" :alt="pc['valuation_image_alt']" class="_w-60">
                    </div>
                    <div class="col-12 col-sm p-4">
                      <h2 class="h3" :class="'text-'+pc['valuation_title_color']">Address: {{ item.full_address ? item.full_address : item.Address+' '+item.City+' '+item.StateOrProvince+' '+item.PostalCode+' ' }}</h2>
                      <p class="m-0" :class="'text-'+pc['valuation_text_color']">
                        <span class="mr-2"><Icon icon="ri:hotel-bed-line" /> Beds : {{item.BedroomsTotal ? item.BedroomsTotal : '?'}}</span>
                        <span class="mr-2"><Icon icon="ri:contrast-drop-line" /> Baths : {{item.BathroomsTotalInteger ? item.BathroomsTotalInteger : '?'}}</span>
                        <span class="mr-2"><Icon icon="ri:ruler-2-line" /> SQFT : {{item.LivingArea ? item.LivingArea : '?'}}</span>
                      </p>
                    </div>
                  </div>
                </div>
                <div class="row m-0">
                  <div class="col-sm-6 p-0">
                    <div data-aos="fade-zoom-in">
                      <img class="w-100" :src="'https://maps.googleapis.com/maps/api/streetview?size=640x480&location='+item.Latitude+','+item.Longitude+'&pitch=10&key='+google_key" alt="What's your property worth?">
                    </div>
                  </div>
                  <div class="col-sm-6 p-0">
                    <img class="w-100" :src="'https://maps.google.com/maps/api/staticmap?center='+item.Latitude+','+item.Longitude+'&zoom=15&markers=33.7225519,-112.2015274&size=640x480&key='+google_key" alt="Interested in a more in depth valuation on your property?">
                  </div>
                </div>
                <div class="mb-5">
                  <div class="row">
                    <div class="col-sm-6 mt-5 text-center border-right border-light">
                      <p v-if="item.valuations.zillow.amount > 0" class="h2">{{formatPrice(item.valuations.zillow.amount, true, false)}}</p>
                      <p v-if="item.valuations.zillow.amount > 0" class="">Range: {{item.valuations.zillow.low ? formatPrice(item.valuations.zillow.low, true, false) : '?'}} to {{item.valuations.zillow.high ? formatPrice(item.valuations.zillow.high, true, false) : '?'}}</p>
                      <p v-else class="_f-s-25 font-weight-light">Valuation<br>not found</p>
                      <small class="text-muted">Powered by</small>
                      <div class="mt-1"><a href="https://zillow.com" target="_blank"><img src="/images/zillow.png" alt="Zillow Zestimate Valuation" class="_h-25"></a></div>
                    </div>
                    <div class="col-sm-6 mt-5 text-center">
                      <p v-if="item.valuations.rpr.amount > 0" class="h2">{{formatPrice(item.valuations.rpr.amount, true, false)}}</p>
                      <p v-if="item.valuations.rpr.amount > 0" class="">Range: {{item.valuations.rpr.low ? formatPrice(item.valuations.rpr.low, true, false) : '?'}} to {{item.valuations.rpr.high ? formatPrice(item.valuations.rpr.high, true, false) : '?'}}</p>
                      <p v-else class="_f-s-25 font-weight-light">Valuation<br>not found</p>
                      <small class="text-muted">Powered by</small>
                      <div class="mt-1"><a href="https://www.narrpr.com" target="_blank"><img src="/images/rpr.jpg" alt="RPR Home Valuation" class="_h-25"></a></div>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="pc['post_btn'] && pc['post_btn'].length" class="text-center mt-5">
                <a v-for="(btn, btn_i) in pc['post_btn']" :key="btn_i" v-if="btn['text'] || btn['pre_icon'] || btn['post_icon']" class="btn btn-lg mb-3 mx-3" :class="'btn-'+btn['color']" :href="btn['url']" target="_blank">
                  <Icon v-if="btn['pre_icon']" :icon="btn['pre_icon']" height="20"></Icon>
                  <span v-if="btn['pre_icon'] && btn['text']" class="border-left mx-3"></span>
                  {{ btn['text'] }}
                  <span v-if="btn['post_icon'] && btn['text']" class="border-left mx-3"></span>
                  <Icon v-if="btn['post_icon']" :icon="btn['post_icon']" height="20"></Icon>
                </a>
              </div>
              
            </div>
          </div>
        </div>

      </section>
    </div>

  </div>

</template>
